'use strict';

var Data = require('./../../../../storage/app/countries.json');
var Timezones = require('./../../../../storage/app/timezones.json');
var States = require('./../../../../storage/app/provinces.json');
var _map    = require('lodash/map');
var _filter = require('lodash/filter');
var _sortBy = require('lodash/sortBy');
var _uniq = require('lodash/uniq');
var _reduceRight = require('lodash/reduceRight');

module.exports = {
	_data: Data,
	_timezones: Timezones,
	_states: States,
	_priority: ['US', 'CA', 'GB', 'AU'],
	
	data() {
		return _sortBy(
			_sortBy(this._data, (i) => i.name.common), 
			(i) => this._priority.indexOf(i.cca2) === -1 ? this._priority.length : this._priority.indexOf(i.cca2)
		)
	},
	callingCodes() {
		return _map(
			_filter(this.data(), (c) => c.callingCode.length > 0), 
			(i) => {return { key: i.cca2, name: i.name.common, value: "+" + i.callingCode[0]}}
		)
	},
	locales() {
		return _map(
			_filter(this.data(), (c) => Object.keys(c.languages).length > 0),
			(i) => {return {key: i.cca2, name: i.name.common, value: Object.keys(i.languages)[0].substr(0,2) + "-" + i.cca2.toUpperCase() }}
		)
	},
	currencies() {
		var priority = ['USD', 'EUR', 'GBP', 'CAD', 'AUD']
		return _sortBy(
			_uniq(
				_reduceRight(this._data, (r, i) => r.concat(i.currency), [])
			).sort(),
			(i) => priority.indexOf(i) === -1 ? priority.length : priority.indexOf(i)
		)
	},
	symbols() {
		return {'AED': 'د.إ','AFN': '؋','ALL': 'L','AMD': '֏','ANG': 'ƒ','AOA': 'Kz','ARS': '$','AUD': '$','AWG': 'ƒ','AZN': '₼','BAM': 'KM','BBD': '$','BDT': '৳','BGN': 'лв','BHD': '.د.ب','BIF': 'FBu','BMD': '$','BND': '$','BOB': '$b','BRL': 'R$','BSD': '$','BTC': '฿','BTN': 'Nu.','BWP': 'P','BYR': 'Br','BYN': 'Br','BZD': 'BZ$','CAD': '$','CDF': 'FC','CHF': 'CHF','CLP': '$','CNY': '¥','COP': '$','CRC': '₡','CUC': '$','CUP': '₱','CVE': '$','CZK': 'Kč','DJF': 'Fdj','DKK': 'kr','DOP': 'RD$','DZD': 'دج','EEK': 'kr','EGP': '£','ERN': 'Nfk','ETB': 'Br','ETH': 'Ξ','EUR': '€','FJD': '$','FKP': '£','GBP': '£','GEL': '₾','GGP': '£','GHC': '₵','GHS': 'GH₵','GIP': '£','GMD': 'D','GNF': 'FG','GTQ': 'Q','GYD': '$','HKD': '$','HNL': 'L','HRK': 'kn','HTG': 'G','HUF': 'Ft','IDR': 'Rp','ILS': '₪','IMP': '£','INR': '₹','IQD': 'ع.د','IRR': '﷼','ISK': 'kr','JEP': '£','JMD': 'J$','JOD': 'JD','JPY': '¥','KES': 'KSh','KGS': 'лв','KHR': '៛','KMF': 'CF','KPW': '₩','KRW': '₩','KWD': 'KD','KYD': '$','KZT': 'лв','LAK': '₭','LBP': '£','LKR': '₨','LRD': '$','LSL': 'M','LTC': 'Ł','LTL': 'Lt','LVL': 'Ls','LYD': 'LD','MAD': 'MAD','MDL': 'lei','MGA': 'Ar','MKD': 'ден','MMK': 'K','MNT': '₮','MOP': 'MOP$','MRO': 'UM','MRU': 'UM','MUR': '₨','MVR': 'Rf','MWK': 'MK','MXN': '$','MYR': 'RM','MZN': 'MT','NAD': '$','NGN': '₦','NIO': 'C$','NOK': 'kr','NPR': '₨','NZD': '$','OMR': '﷼','PAB': 'B/.','PEN': 'S/.','PGK': 'K','PHP': '₱','PKR': '₨','PLN': 'zł','PYG': 'Gs','QAR': '﷼','RMB': '￥','RON': 'lei','RSD': 'Дин.','RUB': '₽','RWF': 'R₣','SAR': '﷼','SBD': '$','SCR': '₨','SDG': 'ج.س.','SEK': 'kr','SGD': '$','SHP': '£','SLL': 'Le','SOS': 'S','SRD': '$','SSP': '£','STD': 'Db','STN': 'Db','SVC': '$','SYP': '£','SZL': 'E','THB': '฿','TJS': 'SM','TMT': 'T','TND': 'د.ت','TOP': 'T$','TRL': '₤','TRY': '₺','TTD': 'TT$','TVD': '$','TWD': 'NT$','TZS': 'TSh','UAH': '₴','UGX': 'USh','USD': '$','UYU': '$U','UZS': 'лв','VEF': 'Bs','VND': '₫','VUV': 'VT','WST': 'WS$','XAF': 'FCFA','XBT': 'Ƀ','XCD': '$','XOF': 'CFA','XPF': '₣','YER': '﷼','ZAR': 'R','ZWD': 'Z$'}
	},
	timezones() {
		return _map(this._timezones, (v,k) => ({key: k, name: v}))
	},
	all() {
		return _map(this.data(), (i) => ({key: i.cca2, name: i.name.common}))
	},
	states(key) {
		return _map(this._states.filter(s => s.country == key), (s) => ({key: s.short ? s.short : s.name, name: s.name}))
	}
}
